// extracted by mini-css-extract-plugin
module.exports = {"blue":"#0f2444","red":"#e41717","logoBlue":"#0fadef","logoRed":"#da1d3e","white":"#fff"};